import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const API = 'https://csksportswear.in/backend/api';

function EnquiryManagement() {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [selected, setSelected] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('csk_token');
  const user = JSON.parse(localStorage.getItem('csk_user') || '{}');

  useEffect(() => {
    if (!token) { navigate('/login'); return; }
    fetchEnquiries();
  }, []);

  const fetchEnquiries = async () => {
    try {
      const res = await axios.get(`${API}/enquiries.php?action=list`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.success) setEnquiries(res.data.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const markAsRead = async (id) => {
    try {
      await axios.post(`${API}/enquiries.php?action=update`, { id, status: 'read' }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchEnquiries();
    } catch (err) { console.error(err); }
  };

  const deleteEnquiry = async (id) => {
    if (!window.confirm('Delete this enquiry?')) return;
    try {
      await axios.get(`${API}/enquiries.php?action=delete&id=${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSelected(null);
      fetchEnquiries();
    } catch (err) { alert('Error!'); }
  };

  const handleWhatsApp = (enquiry) => {
    const msg = encodeURIComponent(`Hi ${enquiry.name}! Thank you for contacting CSK Sportswear. We received your enquiry and will get back to you shortly.`);
    window.open(`https://wa.me/91${enquiry.phone}?text=${msg}`, '_blank');
  };

  const filtered = enquiries.filter(e => filter === 'all' ? true : e.status === filter);

  const newCount = enquiries.filter(e => e.status === 'new').length;
  const readCount = enquiries.filter(e => e.status === 'read').length;

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: '🏠' },
    { path: '/admin/inventory', label: 'Inventory', icon: '📦' },
    ...(user.role === 'admin' ? [{ path: '/admin/pos', label: 'POS Billing', icon: '🧾' }] : []),
    { path: '/admin/reports', label: 'Reports', icon: '📊' },
    { path: '/admin/gallery', label: 'Gallery', icon: '🖼️' },
    { path: '/admin/enquiries', label: 'Enquiries', icon: '📩' },
    ...(user.role === 'admin' ? [
      { path: '/admin/settings', label: 'Settings', icon: '⚙️' },
      { path: '/admin/users', label: 'Users', icon: '👥' },
    ] : []),
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0A0A0A', fontFamily: 'Inter, sans-serif' }}>
      <style>{`
        .enq-sidebar { width: 200px; background: #000; border-right: 1px solid rgba(255,255,255,0.08); display: flex; flex-direction: column; position: fixed; top: 0; left: 0; bottom: 0; z-index: 100; transition: transform 0.3s ease; }
        .enq-main { margin-left: 200px; flex: 1; padding: 32px; }
        .enq-mobile-hdr { display: none; background: #000; padding: 12px 16px; position: fixed; top: 0; left: 0; right: 0; z-index: 99; border-bottom: 1px solid rgba(255,255,255,0.08); align-items: center; justify-content: space-between; }
        .enq-overlay { display: none; position: fixed; inset: 0; background: rgba(0,0,0,0.7); z-index: 99; }
        @media (max-width: 768px) {
          .enq-sidebar { transform: translateX(-100%); }
          .enq-sidebar.open { transform: translateX(0); }
          .enq-main { margin-left: 0; padding: 72px 16px 16px; }
          .enq-mobile-hdr { display: flex; }
          .enq-overlay.show { display: block; }
          .enq-grid { grid-template-columns: 1fr !important; }
        }
        .enq-nav-link { display: flex; align-items: center; gap: 10px; padding: 12px 16px; color: #475569; font-size: 13px; font-weight: 500; text-decoration: none; border-left: 3px solid transparent; transition: all 0.2s; }
        .enq-nav-link:hover { color: white; background: rgba(255,255,255,0.05); }
        .enq-nav-link.active { color: white; background: rgba(0,102,255,0.1); border-left-color: #0066FF; }
        .enq-item { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 16px; cursor: pointer; transition: all 0.2s; }
        .enq-item:hover { border-color: rgba(0,102,255,0.3); background: rgba(0,102,255,0.04); }
        .enq-item.selected { border-color: #0066FF; background: rgba(0,102,255,0.08); }
        .enq-item.new { border-left: 3px solid #0066FF; }
      `}</style>

      {/* Mobile Header */}
      <div className="enq-mobile-hdr">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ color: '#DC2626', fontSize: '20px' }}>★</span>
          <span style={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 800, color: 'white' }}>CSK</span>
        </div>
        <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ background: 'none', border: 'none', color: 'white', fontSize: '22px', cursor: 'pointer' }}>☰</button>
      </div>

      <div className={`enq-overlay ${sidebarOpen ? 'show' : ''}`} onClick={() => setSidebarOpen(false)} />

      {/* Sidebar */}
      <div className={`enq-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div style={{ padding: '16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: '#DC2626', fontSize: '20px' }}>★</span>
            <div>
              <div style={{ fontFamily: 'Montserrat', fontSize: '13px', fontWeight: 800, letterSpacing: '2px', color: 'white' }}>CSK</div>
              <div style={{ fontSize: '8px', color: '#475569', letterSpacing: '1px' }}>ADMIN PANEL</div>
            </div>
          </div>
        </div>
        <div style={{ padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: '13px', fontWeight: 600, color: 'white' }}>{user.name}</div>
          <div style={{ fontSize: '11px', color: '#0066FF', textTransform: 'uppercase', letterSpacing: '1px' }}>{user.role}</div>
        </div>
        <nav style={{ flex: 1, padding: '8px 0', overflowY: 'auto' }}>
          {menuItems.map(item => (
            <Link key={item.path} to={item.path}
              className={`enq-nav-link ${window.location.pathname === item.path ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}>
              <span>{item.icon}</span>
              {item.label}
              {item.path === '/admin/enquiries' && newCount > 0 && (
                <span style={{ marginLeft: 'auto', background: '#DC2626', color: 'white', borderRadius: '50%', width: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700 }}>{newCount}</span>
              )}
            </Link>
          ))}
        </nav>
        <div style={{ padding: '12px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <button onClick={() => { localStorage.clear(); navigate('/login'); }} style={{ width: '100%', padding: '8px', background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '6px', color: '#DC2626', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>🚪 Logout</button>
        </div>
      </div>

      {/* Main */}
      <div className="enq-main">
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
          <div>
            <h1 style={{ fontFamily: 'Montserrat', fontSize: '28px', fontWeight: 800, color: 'white', marginBottom: '4px' }}>
              Enquiries
              {newCount > 0 && <span style={{ marginLeft: '12px', background: '#DC2626', color: 'white', borderRadius: '50px', padding: '2px 10px', fontSize: '14px' }}>{newCount} new</span>}
            </h1>
            <p style={{ color: '#475569', fontSize: '14px' }}>Customer enquiries from website</p>
          </div>
        </div>

        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '16px', marginBottom: '24px' }}>
          {[
            { label: 'Total', value: enquiries.length, icon: '📩', color: '#0066FF' },
            { label: 'New', value: newCount, icon: '🔔', color: '#DC2626' },
            { label: 'Read', value: readCount, icon: '✅', color: '#16A34A' },
          ].map((s, i) => (
            <div key={i} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', padding: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontSize: '11px', color: '#475569', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '1px' }}>{s.label}</div>
                  <div style={{ fontSize: '28px', fontWeight: 800, color: s.color }}>{s.value}</div>
                </div>
                <div style={{ fontSize: '28px' }}>{s.icon}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Filter Tabs */}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
          {[
            { id: 'all', label: 'All' },
            { id: 'new', label: '🔔 New' },
            { id: 'read', label: '✅ Read' },
          ].map(f => (
            <button key={f.id} onClick={() => setFilter(f.id)} style={{ padding: '8px 20px', border: 'none', borderRadius: '8px', background: filter === f.id ? '#0066FF' : 'rgba(255,255,255,0.05)', color: filter === f.id ? 'white' : '#475569', fontSize: '13px', fontWeight: 600, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
              {f.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', color: '#475569', padding: '60px' }}>Loading...</div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#475569' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📩</div>
            <div>No enquiries yet</div>
          </div>
        ) : (
          <div className="enq-grid" style={{ display: 'grid', gridTemplateColumns: selected ? '1fr 1fr' : '1fr', gap: '16px' }}>

            {/* List */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {filtered.map(e => (
                <div key={e.id}
                  className={`enq-item ${e.status === 'new' ? 'new' : ''} ${selected?.id === e.id ? 'selected' : ''}`}
                  onClick={() => { setSelected(e); if (e.status === 'new') markAsRead(e.id); }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: e.status === 'new' ? 'rgba(0,102,255,0.2)' : 'rgba(255,255,255,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: 700, color: e.status === 'new' ? '#0066FF' : '#475569', flexShrink: 0 }}>
                        {e.name?.charAt(0).toUpperCase()}
                      </div>
                      <div>
                        <div style={{ fontSize: '14px', fontWeight: 600, color: 'white' }}>{e.name}</div>
                        <div style={{ fontSize: '12px', color: '#475569' }}>{e.phone}</div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {e.status === 'new' && (
                        <span style={{ background: '#DC2626', color: 'white', padding: '2px 8px', borderRadius: '50px', fontSize: '10px', fontWeight: 700 }}>NEW</span>
                      )}
                      <div style={{ fontSize: '11px', color: '#475569' }}>{new Date(e.created_at).toLocaleDateString('en-IN')}</div>
                    </div>
                  </div>
                  <p style={{ fontSize: '13px', color: '#94A3B8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', margin: 0 }}>
                    {e.message}
                  </p>
                </div>
              ))}
            </div>

            {/* Detail Panel */}
            {selected && (
              <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '16px', padding: '24px', position: 'sticky', top: '24px', alignSelf: 'flex-start' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                  <h3 style={{ fontFamily: 'Montserrat', fontSize: '16px', fontWeight: 700, color: 'white' }}>Enquiry Detail</h3>
                  <button onClick={() => setSelected(null)} style={{ background: 'none', border: 'none', color: '#475569', fontSize: '20px', cursor: 'pointer' }}>✕</button>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', padding: '16px', background: 'rgba(255,255,255,0.03)', borderRadius: '10px' }}>
                  <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'rgba(0,102,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', fontWeight: 700, color: '#0066FF' }}>
                    {selected.name?.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <div style={{ fontSize: '16px', fontWeight: 700, color: 'white' }}>{selected.name}</div>
                    <div style={{ fontSize: '13px', color: '#0066FF' }}>{selected.phone}</div>
                  </div>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <div style={{ fontSize: '11px', color: '#475569', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>Message</div>
                  <div style={{ background: 'rgba(255,255,255,0.03)', borderRadius: '10px', padding: '14px', fontSize: '14px', color: '#94A3B8', lineHeight: 1.7 }}>
                    {selected.message}
                  </div>
                </div>

                <div style={{ marginBottom: '24px', fontSize: '12px', color: '#475569' }}>
                  📅 {new Date(selected.created_at).toLocaleString('en-IN')}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <button onClick={() => handleWhatsApp(selected)} style={{ width: '100%', padding: '12px', background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.3)', borderRadius: '8px', color: '#25D366', fontSize: '14px', fontWeight: 700, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
                    💬 Reply on WhatsApp
                  </button>
                  <button onClick={() => window.open(`tel:${selected.phone}`)} style={{ width: '100%', padding: '12px', background: 'rgba(0,102,255,0.1)', border: '1px solid rgba(0,102,255,0.3)', borderRadius: '8px', color: '#0066FF', fontSize: '14px', fontWeight: 700, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
                    📞 Call Customer
                  </button>
                  <button onClick={() => deleteEnquiry(selected.id)} style={{ width: '100%', padding: '12px', background: 'rgba(220,38,38,0.1)', border: '1px solid rgba(220,38,38,0.3)', borderRadius: '8px', color: '#DC2626', fontSize: '14px', fontWeight: 700, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
                    🗑 Delete
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default EnquiryManagement;
